"use client";

import { useEffect, useState } from "react";
import { GoogleTagManager } from "@next/third-parties/google";

type Props = {
  gtmId?: string;
};

export default function GTMLoader({ gtmId = "GTM-M4BC4Q6" }: Props) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkConsentModel = () => {
      try {
        // Safely navigate nested properties
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const win = window as any;
        return !!(
          win?.truste &&
          win.truste.eu &&
          win.truste.eu.bindMap &&
          win.truste.eu.bindMap.consentModel
        );
      } catch {
        return false;
      }
    };

    if (checkConsentModel()) {
      setReady(true);
      return undefined;
    }

    const interval = setInterval(() => {
      if (!mounted) return;
      if (checkConsentModel()) {
        setReady(true);
        clearInterval(interval);
      }
    }, 200);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  if (!ready) return null;

  return <GoogleTagManager gtmId={gtmId} />;
}
